module.exports = __webpack_public_path__ + "static/media/CodeQuest3.0 - SY - Week 3.38e271b9.pdf";